import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Config } from '../../../config/config';
import { useSessionService } from '../../../services/session/use-session.service';
export const AdminLoginContainer = () => {

  const { token } = useParams();
  const history = useHistory();
  const {setToken} = useSessionService();

  useEffect(() => {
    if(token) {
      setToken(token);
      history.push(Config.routePaths.main.vendor.dashboard.profile.path);
    }
  }, []);
  return (
   <div/>
  );
};
